var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "SoundMute",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>icon_library</title>
  <g id="svg-fg">
    <path d="M23.11,38.6V25.8a1.09,1.09,0,0,1,1.25-1.25c2,0,4,0,5.93,0a1.38,1.38,0,0,0,.78-.26q4-3.06,7.93-6.16a1.11,1.11,0,0,1,1.9.94q0,6.47,0,13t0,13a1.14,1.14,0,0,1-.6,1.16A1.17,1.17,0,0,1,39,45.88q-3.73-2.91-7.5-5.8a1.22,1.22,0,0,0-.7-.23c-2.15,0-4.29,0-6.44,0A1.1,1.1,0,0,1,23.11,38.6Zm9.15-12.51a.78.78,0,0,0-.23.53c0,3.59,0,7.19,0,10.78a.66.66,0,0,0,.28.6c1.46,1.11,2.9,2.24,4.34,3.36L38.73,43V21.06l-.21.15C36.43,22.83,34.34,24.45,32.26,26.09Zm-7,11.59H29.8v-11H25.26Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/sound_mute.svg